import $ from "jquery";
import {
  ChangeGlobalMorph,
  ConvertMorphValue,
  pergola,
  pergolaConst,
} from "../../../../../../core/3d-configurator";
import { MORPH_DATA, state } from "../../../../../../core/settings";
import {
  lightRange,
  shadesRange,
  slidingGlassDoors,
} from "../../../../../portal/rangeArrays";
import "./generateRange.scss";
import {
  countActiveSystemsInPergola,
  countVisibleObjectsByName,
} from "../../../../../summary/summary-page/summaryPage";
import { updateTextParam } from "../interfaceGroupInputs";

export function capitalize(str) {
  if (str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  return str;
}

export const typesDirection = {
  width: "width",
  length: "length",
  height: "height",
};

export function formatFeetInches(value) {
  const feet = Math.floor(value);
  const inchesDecimal = (value - feet) * 12;
  const inches = Math.round(inchesDecimal); // округлюємо до цілого дюйма

  // якщо рівно 12 дюймів — додаємо +1 фут
  if (inches === 12) return `${feet + 1}'`;
  if (inches === 0) return `${feet}'`;
  return `${feet}'${inches}"`;
}

export function addInfoLabel() {
  if (
    state.height > 8 &&
    (countActiveSystemsInPergola(pergolaConst.systemType.sliding_shutters) ||
      countActiveSystemsInPergola(pergolaConst.systemType.sliding_doors))
  ) {
    $(document)
      .find("#info-label")
      .text("Wind resistant is lower than recomended");
  } else {
    $(document).find("#info-label").text("");
  }
}

export function getRangesFromState() {
  return [
    {
      name: "width",
      title: "Width",
      min: state.minDimension,
      max: state.maxWidth,
      step: 1 / 12,
      showLabels: true,
      thumb: true,
      initialValue: state.width,
    },
    {
      name: "length",
      title: "Length",
      min: state.minDimension,
      max: state.maxLength,
      step: 1 / 12,
      showLabels: true,
      thumb: true,
      initialValue: state.length,
    },
    {
      name: "height",
      title: "Height",
      min: state.minDimension,
      max: state.maxHeight,
      step: 1 / 12,
      showLabels: true,
      thumb: true,
      initialValue: state.height,
    },
  ];
}

export function updateRangeLabelsFromState() {
  ["width", "length", "height"].forEach((key) => {
    const capitalKey = key.charAt(0).toUpperCase() + key.slice(1);
    const newMax = state[`max${capitalKey}`];

    const maxLabel = document.getElementById(`range__max-${key}`);
    if (maxLabel) {
      maxLabel.textContent = newMax;
    }

    const rangeInput = document.getElementById(`range__input-${key}`);
    if (rangeInput) {
      rangeInput.setAttribute("max", newMax);
    }
  });
}

export function generateRangeHTML(range) {
  const customRangeHTML = `
    <div class="range">
      <label class="range__label" for="range__input-${range.name}">${
    range.title
  }</label>

      <div class="range__wrapper">
        <input 
          type="range" 
          id="range__input-${range.name}" 
          class="range__input" 
          min="${range.min}" 
          max="${range.max}" 
          step="${range.step}" 
          value="${range.initialValue}">

        ${
          range.thumb
            ? `<div class="range__thumb-value" id="range__thumb-value-${range.name}">${range.initialValue}</div>`
            : ""
        }

        ${
          range.showLabels
            ? `
              <div class="range__values">
                <span class="range__value range__value--min" id="range__min-${
                  range.name
                }">
                  ${range.labelMin ?? range.min}
                </span>
                <span class="range__value range__value--max" id="range__max-${
                  range.name
                }">
  ${range.labelMax ?? range.max}
</span>
              </div>`
            : ""
        }
      </div>
    </div>

    ${
      range.showSwitchAngle &&
      `
         <div class="direction">
             <label class="range__label" for="range__input">Direction</label>

             <div class="direction__switch">
                <p class="direction__switch-off switch_active">Clockwise</p>
        
                <label class="switch">
                    <input type="checkbox" class="switch__input" id="switch-input">
                    <span class="switch__slider"></span>
                </label>
    
                <p class="direction__switch-on">Counter clockwise</p>
             </div>
         </div>
        `
    }
  `;

  const activeSwitchClass = "switch_active";
  const $customRange = $(customRangeHTML);
  const $switchInput = $customRange.find(".switch__input");
  const $rangeLabel = $customRange.find(".range__label");
  const $rangeInputId = $customRange.find(`#range__input-${range.name}`);
  const $rangeInput = $customRange.find(`#range__input-${range.name}`);
  const $rangeThumbValue = $customRange.find(".range__thumb-value");

  // INIT SWITCH BUTTON
  const $slider = $(this).next(".switch__slider");

  function updateSwitchState(isRotated) {
    if (isRotated) {
      $slider.addClass(activeSwitchClass);
      $customRange
        .find(".direction__switch-off")
        .removeClass(activeSwitchClass);
      $customRange.find(".direction__switch-on").addClass(activeSwitchClass);
      $switchInput.prop("checked", true);
    } else {
      $slider.removeClass(activeSwitchClass);
      $customRange.find(".direction__switch-off").addClass(activeSwitchClass);
      $customRange.find(".direction__switch-on").removeClass(activeSwitchClass);
      $switchInput.prop("checked", false);
    }
  }

  // // updateSwitchState(state.isRotated);

  // // HANDLE SWITCH
  // $switchInput.on("change", function () {
  //   state.isRotated = !state.isRotated;
  //   pergola.update();
  //   // updateSwitchState(state.isRotated);
  // });

  //THUMB HANDLE
  function updateThumbValue(trigger) {
   

    const min = parseInt($rangeInput.attr("min"), 10);
    const max = parseInt($rangeInput.attr("max"), 10);
    // let value = parseInt($rangeInput.val(), 10);
    let value;

    const labelInputs = $rangeLabel.text().trim();
    let newHeaderText = "";

    //update Param Head
    if (range.thumb) {
      switch (range.name) {
        case "width":
          value = +state.width.toFixed(2);
          MORPH_DATA.width.initValue = value;

          break;
        case "length":
          value = +state.length.toFixed(2);
          MORPH_DATA.length.initValue = value;

          break;
        case "height":
          value = +state.height.toFixed(2);
          MORPH_DATA.height.initValue = value;

          break;
      }

      newHeaderText = `${formatFeetInches(
        MORPH_DATA.width.initValue
      )} x ${formatFeetInches(MORPH_DATA.length.initValue)} x ${formatFeetInches(
        MORPH_DATA.height.initValue
      )}`;

      $(trigger)
        .closest(".interface__group")
        .find(".interface__group__head__param")
        .text(newHeaderText);
    }

    //calc thumb value position
    const borderForHidePercent = 10; // % by diapasone
    const borderForHideMaxPercent = 10; // % by diapasone
    const rangeSpan = max - min;

    const borderForHide = (borderForHidePercent / 100) * rangeSpan;
    const borderForHideMax = (borderForHideMaxPercent / 100) * rangeSpan;

    if (range.thumb) {
      if (
        (value >= min &&
          value <= min + borderForHide &&
          rangeSpan > borderForHide * 2) ||
        (value >= max - borderForHideMax &&
          value <= max &&
          rangeSpan > borderForHideMax * 2)
      ) {
        $rangeThumbValue.hide();
      } else {
        $rangeThumbValue.show();
        $rangeThumbValue.text(formatFeetInches(value));

        const percent = ((value - min) / rangeSpan) * 100;
        const thumbOffset = $rangeThumbValue.outerWidth() / 2;
        $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
      }

      if (value === min || value === max) {
        $rangeThumbValue.hide();
      }
    }

    const fillPercent = ((value - min) / (max - min)) * 100;

    // забезпечуємо точність до 4 знаків після коми
    const precisePercent = parseFloat(fillPercent.toFixed(2));

    // оновлення градієнту з точним значенням
    $rangeInput.css(
      "background",
      `linear-gradient(to right,
      #DB1A7D 0%,
      #DB1A7D ${precisePercent}%,
       rgba(219, 26, 125, 0.1) ${precisePercent}%,
       rgba(219, 26, 125, 0.1) 100%)`
    );
  }

  //init calc
  updateThumbValue();

  async function changeMorph(directions, inputValue, range, modelForExport) {
    switch (directions) {
      case typesDirection.width:
        const valueInt = ConvertMorphValue(
          inputValue,
          range.min,
          range.state.maxWidth
        );

        ChangeGlobalMorph("width", valueInt);
        ChangeGlobalMorph("width_wall", valueInt);

        await pergola.update();

        break;

      case typesDirection.length:
        const valueIntLength = ConvertMorphValue(
          inputValue,
          range.min,
          range.state.maxLength
        );

        ChangeGlobalMorph("length", valueIntLength);
        ChangeGlobalMorph("length_wall", valueIntLength);

        await pergola.update();

        break;

      case typesDirection.height:
        const valueIntHeigth = ConvertMorphValue(
          inputValue,
          range.min,
          range.state.maxHeight
        );

        ChangeGlobalMorph("height", valueIntHeigth);

        await pergola.update();

        break;

      default:
        return console.log("non correct directions");
    }
  }

  //HANDLE Spacing LIGHT
  if (range.title === lightRange[0].title) {
    $rangeInputId.on("input", function (event) {
      state.spacing = event.target.value;
      pergola.update();
    });
  }

  //CONECT 'Rotation' input to MODEL
  if (range.title === "Rotation") {
    console.log($rangeInputId, "range");

    $rangeInputId.on("input", function (event) {
      state.currentRotationZ = event.target.value;
      console.log(event.target.value);
      applyRotationToClones(event.target.value);
    });
  }

  //CONECT 'Glass Doors' range input to MODEL:
  if (range.title === "glassDoors") {
    $rangeInputId.on("input", function (event) {
      state.currentRotationZ = event.target.value;
      console.log(event.target.value);
      applyRotationToClones(event.target.value);
    });
  }

  //CHANGE WIDTH
  if (range.title === capitalize(typesDirection.width)) {
    //INIT WIDTH
    setTimeout(() => {
      // #region ROOF TYPE LOGIC
      if (state.width < 15) {
        if (state.roofType === 2) {
          state.roofType = 1;
          $("#solid-roof input").trigger("click");
        }

        $("#combo-roof").removeClass("active");
        $("#combo-roof").addClass("disable");
      } else {
        $("#combo-roof").removeClass("disable");
      }
      // #endregion
    }, 0);

    //HANDLE WIDTH
    $rangeInputId.on("input", async function (event) {
      state.width = +event.target.value;

      // #region ROOF TYPE LOGIC
      if (state.width < 15) {
        if (state.roofType === 2) {
          state.roofType = 1;
          $("#solid-roof input").trigger("click");
        }

        $("#combo-roof").removeClass("active");
        $("#combo-roof").addClass("disable");
      } else {
        $("#combo-roof").removeClass("disable");
      }
      // #endregion

      //#region SKY LIGHT LOGIC
      if (state.width < 10) {
        state.skyLight = false;

        $("#skylight").removeClass("active");
        $("#skylight").addClass("disable");
      } else {
        $("#skylight").removeClass("disable");
      }
      // #endregion

      pergola.update();
      pergola.checkSystemsInScene();
    });

    setTimeout(() => {
      $(`#range__input-width`).val(`${state.width}`).trigger("input");
    }, 1000);
  }

  //CHANGE LENGHT
  if (range.title === capitalize(typesDirection.length)) {
    //HANDLE LENGHT
    $rangeInputId.on("input", async function (event) {
      state.length = +event.target.value;

      if (state.roofType === 1) {
        $("#thickness .radio__container__item ").each(function () {
          const $input = $(this);
          const id = +$(this).attr("id");

          $input.removeClass("disable");
          $input.removeClass("active");

          //LOGIC FOR SOLID
          switch (true) {
            case id === 3 && state.length > 16 && state.length <= 20:
              $input.addClass("disable");
              $input.removeClass("active");

              state.thickness = state.thickness === 3 ? 4 : state.thickness;
              break;

            case id === 3 && 20 < state.length:
            case id === 4 && 20 < state.length:
              $input.addClass("disable");
              $input.removeClass("active");

              state.thickness = 6;
              break;
          }

          if (id === state.thickness) {
            $input.addClass("active");
          }
        });
      }

      pergola.update();
      pergola.checkSystemsInScene();
    });

    setTimeout(() => {
      $(`#range__input-length`).val(`${state.length}`).trigger("input");
    }, 1000);
  }

  //CHANGE HEIGTH
  if (range.title === capitalize(typesDirection.height)) {
    //INIT HEIGTH
    // changeMorph(typesDirection.height, state.height, range, modelForExport);

    //INIT HEIGTH
    $rangeInputId.on("input", async function (event) {
      state.height = +event.target.value;

      addInfoLabel();
      // await changeMorph(
      //   typesDirection.height,
      //   event.target.value,
      //   range,
      //   modelForExport
      // );

      pergola.update();
    });

    setTimeout(() => {
      if (
        state.height > 8 &&
        (countActiveSystemsInPergola(
          pergolaConst.systemType.sliding_shutters
        ) ||
          countActiveSystemsInPergola(pergolaConst.systemType.sliding_doors))
      ) {
        $(document)
          .find("#info-label")
          .text("Wind resistant is lower than recomended");
      } else {
        $(document).find("#info-label").text("");
      }

      $(`#range__input-height`).val(`${state.height}`).trigger("input");
    }, 3000);
  }

  $rangeInput.on("input", function () {
    updateThumbValue(this);
  });

  return $customRange;
}
